<!--
 * @Author: wh
 * @Date: 2020-08-24 19:10:33
 * @LastEditTime: 2021-01-27 11:21:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\leaderTerminal\DataBulletin\accountsReceive.vue
-->
<template>
    <div class="accountsReceive">
        <div class="search-conditions-con">
            <div class="search-conditions">
                <span class="time-con">
                    <span>{{ date1 }}</span>
                </span>
                <span class="time-con" @click="handleShowDatePop">
                    <span>{{ date2 }}</span>
                </span>
            </div>
        </div>

        <div class="main">
            <div class="top">
                <div class="header">
                    <div class="item item0">
                        <p class="num">
                            {{ info.current_month_balance_total }}
                        </p>
                        <p class="describe">
                            本月余额(万元)
                        </p>
                    </div>
                    <div class="item item1">
                        <p class="num">
                            {{ info.beginning_year_balance_total }}
                        </p>
                        <p class="describe">
                            年初余额(万元)
                        </p>
                    </div>
                    <div class="item item2">
                        <p class="num">
                            {{ info.beginning_year_ratio_total }}
                        </p>
                        <p class="describe">
                            年初比(万元)
                        </p>
                    </div>
                </div>
                <div class="header">
                    <div class="item item3">
                        <p class="num">
                            {{ info.month_rate_recovery_total }}
                        </p>
                        <p class="describe">
                            本月货款回收率
                        </p>
                    </div>
                    <div class="item item4">
                        <p class="num">
                            {{ info.year_rate_recovery_total }}
                        </p>
                        <p class="describe">
                            本年货款回收率
                        </p>
                    </div>
                </div>
            </div>
            <div class="split"></div>
            <div class="charts_header">
                <van-tabs
                    type="card"
                    color="#3495FB"
                    v-model="tabActive"
                    @click="tabSelect"
                >
                    <template v-for="(item,index) in tabData">
                        <van-tab :key="index" :title="item.name"></van-tab>
                    </template>
                </van-tabs>
            </div>
            <div class="chart-con">
                <div id="balance-chart"></div>
            </div>
            <div class="split"></div>
            <div class="chart-con">
                <div id="recovery-chart"></div>
            </div>
        </div>
        <van-popup v-model="showDatePop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="date2Model"
                type="year-month"
                title="选择年月"
                @confirm="confirmDate"
                @cancel="showDatePop=false"
            ></van-datetime-picker>
        </van-popup>
    </div>
</template>

<script>
import util from '@/assets/js/utils';
export default {
    components: {},
    props: {},
    data() {
        return {
            showDatePop: false,
            info: {
                current_month_balance_total: 0,
                beginning_year_balance_total: 0,
                beginning_year_ratio_total: 0,
                month_rate_recovery_total: 0,
                year_rate_recovery_total: 0,
            }, // 数据信息
            listData: [], // 列表数据
            // 当前日期
            date1: '',
            date2: '',
            date2Model: '',
            // tab选项
            tabData: [{
                name: '按销售公司',
                val: 1,
            }, {
                name: '按合同类型',
                val: 2,
            }],
            // tab默认值
            tabActive: 0,

            controlTime: '',
        };
    },
    watch: {
        date2(time) {
            const timeDate = new Date(time);
            if (timeDate.getFullYear() === 2021 && this.controlTime.includes('2021')) {
                this.date1 = util.timeFormat( new Date(this.controlTime), 'yyyy-MM');
            } else {
                this.date1 = util.timeFormat( new Date(timeDate.getFullYear(), 0), 'yyyy-MM');
            }
            this.getData();
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.controlTime = await this.getControlTime() || '';
            this.date2 = util.timeFormat( new Date(), 'yyyy-MM');
        },
        tabSelect() {
            this.getData();
        },
        handleShowDatePop() {
            this.date2Model = new Date(this.date2);
            this.showDatePop = true;
        },
        confirmDate(value) {
            this.date2 = util.timeFormat(value, 'yyyy-MM');
            this.showDatePop = false;
        },
        // 获取管控时间
        async getControlTime() {
            const path = '/interfaceApi/report/leadercockpit/get_year_accounts_receivable_data_time';
            this.controlTime = await this.$axios.$get(path, { defEx: true });
        },
        // 获取全部合同应收
        getData() {
            this.$toast.loading();
            const path = '/interfaceApi/report/leadercockpit/get_year_accounts_receivable_data?type=' + this.tabData[this.tabActive].val
                    + `&begin_time=${this.date1}&end_time=${this.date2}`;
            return this.$axios.get(path).then(res => {
                if (res) {
                    this.info.current_month_balance_total = (res.current_month_balance_total / 10000).toFixed(2);
                    this.info.beginning_year_balance_total = (res.beginning_year_balance_total / 10000).toFixed(2);
                    this.info.beginning_year_ratio_total = (res.beginning_year_ratio_total / 10000).toFixed(2);
                    this.info.month_rate_recovery_total = res.month_rate_recovery_total + '%';
                    this.info.year_rate_recovery_total = res.year_rate_recovery_total + '%';
                    this.listData = res.list || [];

                    this.lineColumn('balance-chart');
                    this.pieChart('recovery-chart');
                }
                this.$toast.clear();
            });
        },
        lineColumn(obj) {
            const data = {
                xAxis: [],
                list1: [], // 年度累计应收
                list2: [], // 年度累计实收
                list3: [], // 本年货款回收率
            };

            this.listData.forEach(item => {
                data.xAxis.push(item.show_name);
                data.list1.push((item.year_accumulated_accounts_receivable / 10000).toFixed(2));
                data.list2.push((item.year_accumulated_net_receipts / 10000).toFixed(2));
                data.list3.push(item.year_rate_recovery);
            });
            const lineColumnChart = window.$globalHub.$echarts.init(document.getElementById(obj));
            const option = {
                title: {
                    text: '货款回收率',
                    left: 'left',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        label: {
                            show: true,
                        },
                    },
                },
                legend: {
                    textStyle: {
                        color: '#666666',
                    },
                    top: 30,
                },
                grid: {
                    left: 30,
                    top: 90,
                    right: 30,
                    bottom: 40,
                },
                xAxis: [{
                    data: data.xAxis,
                    boundaryGap: true,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(133,133,133,0.2)',
                        },
                    },
                    splitArea: {
                        color: '#f00',
                        lineStyle: {
                            color: '#f00',
                        },
                    },
                    axisLabel: {
                        color: '#979EA7',
                        rotate: 20,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                }],
                yAxis: [
                    {
                        name: '(万元)',
                        nameLocation: 'end',
                        nameTextStyle: {
                            color: '#979EA7',
                            padding: '',
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,0.1)',
                                width: 0.5,
                                type: 'dashed',
                            },
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                            },
                        },
                        axisLabel: {
                            show: true,
                            color: '#979EA7',
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                    {
                        name: '(%)',
                        nameLocation: 'end',
                        nameTextStyle: {
                            color: '#979EA7',
                            padding: '',
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                                width: 0.5,
                                type: 'solid',
                            },
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                            },
                        },
                        axisLabel: {
                            show: true,
                            color: '#979EA7',
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                ],
                series: [
                    {
                        name: '年度累计应收',
                        barWidth: 15,
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#55A7FE',
                                },
                                {
                                    offset: 1,
                                    color: '#3E79C5',
                                },
                                ]),
                            },
                        },
                        data: data.list1,
                    },
                    {
                        name: '年度累计实收',
                        type: 'bar',
                        barWidth: 15,
                        yAxisIndex: 0,
                        stack: '总累计实收',
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#EFAB54',
                                },
                                {
                                    offset: 1,
                                    color: '#FA8C47',
                                },
                                ]),
                            },
                        },
                        data: data.list2,
                    },
                    {
                        name: '本年货款回收率',
                        type: 'line',
                        // smooth: true,
                        showSymbol: true,
                        symbolSize: 8,
                        lineStyle: {
                            normal: {
                                color: '#21BC9A',
                                width: 2,
                            },
                        },
                        yAxisIndex: 1,
                        label: {
                            show: false,
                            position: 'top',
                            textStyle: {
                                color: '#FC9343',
                            },
                        },
                        itemStyle: {
                            color: '#6c50f3',
                            borderColor: '#fff',
                            borderWidth: 2,
                            shadowColor: 'rgba(0, 128, 100, 0.5)',
                            shadowBlur: 0,
                            shadowOffsetY: 2,
                            shadowOffsetX: 2,
                            normal: {
                                color: '#21BC9A',
                                lineStyle: {
                                    color: '#21BC9A',
                                },
                            },
                        },
                        data: data.list3,
                    },
                ],
            };
            lineColumnChart.setOption(option);
        },

        pieChart(obj) {
            const chart = window.$globalHub.$echarts.init(document.getElementById(obj));
            // 默认四种渐变颜色
            const colors = [
                ['#76E0A8', '#13BD63'],
                ['#71C6B0', '#4EA496'],
                ['#48A0D8', '#7FD0FE'],
                ['#F79187', '#EA5D5D']];


            const data = [];
            this.listData.forEach(item => {
                data.push({
                    name: item.show_name,
                    value: item.current_month_balance,
                });
            });
            let total = 0;
            data.forEach(item => {
                total += item.value;
            });
            data.forEach(item => {
                item.name += '(' + (item.value / total * 100).toFixed(1) + '%)';
                item.value = (item.value / 10000).toFixed(2);
            });
            const result = [];
            data.forEach((item, index) => {
                const obj = {
                    value: item.value,
                    name: item.name,
                    label: {
                        alignTo: 'edge',
                        formatter: '{name|{b}} \n{value|{c}万}',
                        minMargin: 5,
                        edgeDistance: 0,
                        lineHeight: 18,
                        rich: {
                            name: {
                                fontSize: 11,
                                color: '#666',
                            },
                            value: {
                                fontSize: 11,
                                color: '#666',
                            },
                        },
                    },
                };
                if (index < colors.length) {
                    obj.itemStyle = {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: colors[index][0], // 0% 处的颜色
                            }, {
                                offset: 1, color: colors[index][1], // 100% 处的颜色
                            }],
                            global: false, // 缺省为 false
                        },
                    };
                }
                result.push(obj);
            });
            const option = {
                title: {
                    text: '本月余额',
                    left: 'left',
                },
                series: [
                    {
                        type: 'pie',
                        radius: '45%',
                        center: ['50%', '50%'],
                        selectedMode: 'single',
                        data: result,
                        labelLayout: function (params) {
                            const isLeft = params.labelRect.x < chart.getWidth() / 2;
                            const points = params.labelLinePoints;
                            // Update the end point.
                            points[2][0] = isLeft
                                ? params.labelRect.x
                                : params.labelRect.x + params.labelRect.width;

                            return {
                                labelLinePoints: points,
                            };
                        },
                        emphasis: {
                            show: false,
                        },
                    },
                ],
            };
            chart.setOption(option);
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="stylus" scoped>
    .accountsReceive
        background #fff
        width 100%
        height 100%
        .charts_header
            margin 12rpx 30rpx
            .van-tabs__nav
                margin 0
        .search-conditions-con
            padding 10rpx
            .search-conditions
                font-size 16rpx
                height 45rpx
                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
                border-radius 4rpx
                padding 10rpx 20rpx
                display flex
                justify-content space-around
                line-height 25rpx
                .time-con
                    position relative
                    flex 1
                    text-align center
                    &:first-child
                        &:after
                            content ''
                            position absolute
                            right 10rpx
                            height 15rpx
                            border-right 1px solid #D7D7D7
                            margin-top 5rpx
                .iconfont
                    font-size 14rpx
                    color #979EA7
                    margin-left 5rpx
                .org
                    flex 1
                    text-align center
                    .org-name
                        color #3495FB
        .main
            height calc(100% - 65rpx)
            overflow-y auto
            .top
                padding 0 10rpx 10rpx 10rpx
                h4
                    margin-top 10rpx
                    span
                        font-size 12rpx
                        color #979EA7
                .header
                    display flex
                    margin-top 10rpx
                    .item
                        flex-shrink 0
                        width calc(100%/3)
                        text-align center
                        padding 3rpx 0 5rpx 0
                        .describe
                            font-size 12rpx
                            color #979EA7
                        .num
                            font-size 18rpx
                            margin-bottom 3rpx
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                        &.item0
                            .num
                                color #5588F1
                        &.item1
                            .num
                                color #FA8436
                        &.item2
                            border 1px solid #DDD4FF
                            background rgba(134, 107, 238, 0.08)
                            .describe
                                color #333333
                            .num
                                color #866BEE
                        &.item3
                            border 1px solid #BAEBF0
                            background rgba(33, 189, 204, 0.08)
                            .describe
                                color #333333
                            .num
                                color #21BDCC
                        &.item4
                            .num
                                color #FFB729
                table
                    width 100%
                    border-spacing 0px
                    border-collapse collapse
                    margin-top 10rpx
                    table-layout fixed
                    th
                        background rgba(235,240,252,1)
                        height 45rpx
                        border 2.5rpx solid #fff
                        border-collapse collapse
                        font-size 14rpx
                        font-weight normal
                    td
                        border 2.5rpx solid #fff
                        border-collapse collapse
                        height 45rpx
                        text-align center
                        width 40rpx
                        font-size 14rpx
                        background rgba(85,136,241,.04)
                        width 25%
                        color #5588F1
                        &.row-tit
                            color #333333
                            background rgba(235,240,252,1)
                    tbody
                        tr
                            &.activeRow
                                td
                                    background rgba(250,132,54,1)
                                    box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                    color #fff
                                .row-tit
                                    color #823802
                                    background rgba(245,242,237,1)
                                    box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                    border 1px solid rgba(222,227,239,1)
            .split
                background #F0F0F0
                height 15rpx
            .chart-con
                padding 10rpx
                h4
                    margin 10rpx 0
                #balance-chart
                    height 235rpx
                #recovery-chart
                    height 235rpx
</style>
